var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var invalid = ref.invalid;
return [_c('a-modal',{staticClass:"set-user-email",attrs:{"title":_vm.modalTitle,"ok-button-props":{
      props: {
        disabled: invalid
      }
    },"ok-text":_vm.okText,"after-close":_vm.afterModalClose},on:{"ok":_vm.submitStep},model:{value:(_vm.isModalOpen),callback:function ($$v) {_vm.isModalOpen=$$v},expression:"isModalOpen"}},[(_vm.currentStep === _vm.SetEmailStepsEnum.Email)?_c('text-input',{staticClass:"mt-0 mb-0",attrs:{"setup":{
        'func': _vm.modelSetter,
        'args': {
          'model': _vm.model,
          'key': 'email',
          'prefix': 'new_',
          'validation': 'required|email',
          'placeholder': _vm.currentEmail
        },
      }},on:{"pressEnter":_vm.submitStep}}):_vm._e(),(_vm.currentStep === _vm.SetEmailStepsEnum.Code)?[_c('a-alert',{attrs:{"show-icon":"","message":_vm.$t('service_sent_you_email_title')}},[_c('a-icon',{attrs:{"slot":"icon","type":"mail"},slot:"icon"}),_c('div',{attrs:{"slot":"description"},domProps:{"innerHTML":_vm._s(_vm.$t('email_modal_confirm_code_alert_description', [ _vm.model.email ]))},slot:"description"})],1),_c('div',{staticClass:"flex text-center sm:justify-end gap-2 mt-2 select-none"},[_c('a',{on:{"click":function($event){$event.preventDefault();return _vm.sendEmailConfirmCodeVm(_vm.model.email)}}},[_vm._v(" "+_vm._s(_vm.$t('email_modal_code_resend'))+" ")]),_c('a-divider',{staticClass:"h-auto",attrs:{"type":"vertical"}}),_c('a',{on:{"click":function($event){$event.preventDefault();_vm.currentStep = _vm.SetEmailStepsEnum.Email}}},[_vm._v(" "+_vm._s(_vm.$t('email_modal_code_step_back'))+" ")])],1),_c('text-input',{staticClass:"mb-0",attrs:{"setup":{
          'func': _vm.modelSetter,
          'args': {
            'model': _vm.model,
            'key': 'code',
            'validation': 'required|integer',
          },
        }},on:{"pressEnter":_vm.submitStep}})]:_vm._e()],2)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }